import React from 'react'
import './Footer.css'

function Footer() {
  var d = new Date();
  var year = d.getFullYear();

  return (
    <section className='sp-footer text-center pt-5'>
      <span>&copy; Copyright plan.com {year} | View the play.plan <a href="/guides/play-plan-guide.pdf" target="_blank">guide</a></span>
    </section>
  )
}

export default Footer
